import { render, staticRenderFns } from "./CreateOrUpdateInfocardModal.vue?vue&type=template&id=3c1e82e4&scoped=true&"
import script from "./CreateOrUpdateInfocardModal.vue?vue&type=script&lang=js&"
export * from "./CreateOrUpdateInfocardModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateOrUpdateInfocardModal.vue?vue&type=style&index=0&id=3c1e82e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1e82e4",
  null
  
)

export default component.exports